import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Iti } from 'intl-tel-input';

export function ItiPhoneNumberValidator(itiInstance: Iti | null): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!itiInstance) {
      return null;
    }
    const rawVal = control.value;

    if (!rawVal || rawVal.trim() === '') {
      return null;
    }

    const number = itiInstance.getNumber();
    const dialCode = `+${itiInstance.getSelectedCountryData()?.dialCode ?? ''}`;
    if (number === dialCode) {
      return null;
    }

    if (!itiInstance.isValidNumberPrecise()) {
      return { invalidPhone: true };
    }

    return null;
  };
}
